import { InfoOutlined } from '@mui/icons-material';
import { Box, Card, CardHeader, Typography, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { ProfileIcon } from '../../components/ProfileIcon';
import { User } from '../../services/dto/Security';
import { getCredentials, getName } from '../../services/utils';
import ProviderProfile from '@containers/ProviderProfile';

type ProviderCardProps = {
  provider: User;
};

const ProviderCard = (props: ProviderCardProps) => {
  const { provider } = props;
  const [showProviderDetails, setShowProviderDetails] =
    useState<boolean>(false);

  return (
    <>
      <Card elevation={0} sx={{ backgroundColor: 'secondary.main', color: 'secondary.contrastText', width: "100%" }}>
        <CardHeader
          avatar={
            <Box sx={{ width: 60, height: 60, borderRadius: '50%', overflow: 'hidden' }}>
              <ProfileIcon user={provider} />
            </Box>
          }
          title={<Typography variant="h6">{getName(provider)}</Typography>}
          subheader={<Typography variant="body2" color="secondary.contrastText">{(provider.providerInfo?.qualifications || []).join(', ')}</Typography>}
          action={
            <IconButton onClick={() => setShowProviderDetails(true)}>
              <InfoOutlined sx={{ color: 'secondary.contrastText' }} />
            </IconButton>
          }
        />
      </Card>

      {showProviderDetails && (
        <ProviderProfile
          bioOnly
          openBio
          provider={provider as any}
          handleBioClose={() => setShowProviderDetails(false)}
        />
      )}
    </>
  );
};

export default ProviderCard;
